import { useEffect } from 'react';

/**
 * Sets document.title, <meta name="description">, <link rel="canonical">
 * and (optionally) a noindex robots tag for a given page. The static,
 * pre-rendered HTML (scripts/prerender.js) already bakes the correct
 * title/description/canonical into each page's build output for crawlers
 * that don't execute JS — this hook keeps them correct for client-side
 * navigation within the single-page app too.
 *
 * @param {string} title
 * @param {string} [description]
 * @param {string} [canonicalPath] - site-relative path, e.g. "/export/ghana"
 * @param {boolean} [noindex] - renders <meta name="robots" content="noindex,nofollow">
 */
export function useDocumentMeta(title, description, canonicalPath, noindex) {
  useEffect(() => {
    if (title) document.title = title;
    if (description) {
      let tag = document.querySelector('meta[name="description"]');
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', 'description');
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', description);
    }
    if (canonicalPath) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', `${window.location.origin}${canonicalPath}`);
    }
    let robots = document.querySelector('meta[name="robots"]');
    if (noindex) {
      if (!robots) {
        robots = document.createElement('meta');
        robots.setAttribute('name', 'robots');
        document.head.appendChild(robots);
      }
      robots.setAttribute('content', 'noindex,nofollow');
    } else if (robots) {
      robots.remove();
    }
  }, [title, description, canonicalPath, noindex]);
}
